module.exports = __webpack_public_path__ + "static/HT-image-369385afc8d845ba36271904ddc662ea.png";